@if (!(loading$|async) && showCart) {
  <div class="container-fluid max-app-width mx-auto">
    @if (!cartCms) {
      <div class="row">
        <!-- summary-cart -->
        @if (hasItems) {
          <div class="col-12 col-lg-9 mb-4">
            <!-- orders table -->
            <cart-orders [mode]="'full'"
              [items]="items"
              [isProductsAmountWithinRange]="isProductsAmountWithinRange()">
            </cart-orders>
            <!-- /orders table -->
          </div>
        } @else {
          <div class="col-12">
            <cart-empty></cart-empty>
          </div>
        }
        @if (hasItems) {
          <div class="col-12 col-lg-3">
            <!-- summary -->
            <div class="card card-with-title bg-white mb-3">
              <h4 class="card-title p-3 pb-0 p-lg-4 pb-lg-0" translate>Current Cart Summary</h4>
              <div class="card-body p-3 p-lg-4">
                <cart-summary [showCoupon]="showCoupon"  [data]="items.Summary"></cart-summary>
              </div>
            </div>
            <!-- /summary -->
            <cart-continue-actions [user]="user" [isContinueToCheckout]="isContinueToCheckout" [items]="items"></cart-continue-actions>
            <!-- /actions -->
          </div>
        }
        <!-- cart-is-empty -->
        <!-- /cart-is-empty -->
      </div>
    } @else {
      <div class="row">
        <cms  class="col-12 px-0" [title]="cartIframeCms"></cms>
      </div>
    }
  </div>
} @else {
  <contentloader></contentloader>
}

<!-- contentloader -->
<!-- /contentloader -->
